// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__gEym4","inputWrap":"Table_inputWrap__1vgrk","col":"Table_col__38BN5","bmiTooltip":"Table_bmiTooltip__R6ToP"};